'use client';

import { useRouter } from 'next/navigation';
import { Home } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function NotFound() {
  const router = useRouter();

  return (
    <div className="flex min-h-[100dvh] items-center justify-center px-4">
      <div className="w-full max-w-md text-center">
        {/* Логотип */}
        <div className="mb-8 flex justify-center">
          <img
            src="/logo.svg"
            alt="Giglan"
            className="h-10 w-auto"
          />
        </div>

        <div className="mb-6">
          <h1 className="text-8xl font-bold text-[#1A1A1A] md:text-9xl">
            404
          </h1>
        </div>

        <h2 className="mb-3 text-2xl font-semibold text-[#1A1A1A] md:text-3xl">
          Страница не найдена
        </h2>

        <p className="mb-8 text-base text-[#666666] md:text-lg">
          К сожалению, запрашиваемая страница не существует или была перемещена.
        </p>

        <div className="flex justify-center">
          <Button
            onClick={() => router.push('/')}
            size="lg"
            className="h-12 bg-[#F46922] text-white hover:bg-[#E05A1B]"
          >
            <Home className="mr-2 h-5 w-5" />
            На главную
          </Button>
        </div>
      </div>
    </div>
  );
}